"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var react_router_1 = require("react-router");
var ACTIVE_CLASS = 'feed-container__tab--active';
var FeedTabs = /** @class */ (function (_super) {
    tslib_1.__extends(FeedTabs, _super);
    function FeedTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedTabs.prototype.render = function () {
        return (React.createElement("nav", { className: "feed-container__tabs" },
            React.createElement("ul", null,
                React.createElement("li", { className: "feed-container__tab" },
                    React.createElement(react_router_1.Link, { to: "/my/feed", activeClassName: ACTIVE_CLASS }, I18n.t('discovery.feed.tabs.feed'))),
                React.createElement("li", { className: "feed-container__tab" },
                    React.createElement(react_router_1.Link, { to: "/my/feed/customize", activeClassName: ACTIVE_CLASS }, I18n.t('discovery.feed.tabs.customize'))),
                React.createElement("li", { className: "feed-container__tab" },
                    React.createElement(react_router_1.Link, { to: "/watched_products", activeClassName: ACTIVE_CLASS }, I18n.t('discovery.feed.tabs.watchList'))),
                React.createElement("li", { className: "feed-container__tab" },
                    React.createElement(react_router_1.Link, { to: "/browsing_history", activeClassName: ACTIVE_CLASS }, I18n.t('discovery.feed.tabs.recentlyViewed'))))));
    };
    return FeedTabs;
}(React.Component));
exports.FeedTabs = FeedTabs;
exports.default = FeedTabs;
//# sourceMappingURL=tabs.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/tabs.js
// module id = wE+9
// module chunks = 20 21